export const regioes = [
  { coRegiao: 1, nomeRegiao: "Norte" },
  { coRegiao: 2, nomeRegiao: "Nordeste" },
  { coRegiao: 3, nomeRegiao: "Sudeste" },
  { coRegiao: 4, nomeRegiao: "Sul" },
  { coRegiao: 5, nomeRegiao: "Centro - Oeste" },
];
